import ConfigurationService from '../api/configuration-service'

export default {
    state: {
        configurations: []
    },
    mutations: {
        updateConfiguration (state, [query, configuration]) {
            let config
            if (state.configurations.length === 0) { config = this.getters.getSpecificConfiguration(query) }

            if (config !== undefined) { config = configuration } else {
                state.configurations.push({
                    section: query.section,
                    identifier: query.identifier,
                    config: configuration
                })
            }
        }
    },
    actions: {
        async getConfiguration (context, query) {
            let config
            if (context.state.configurations.length > 0) { config = this.getters.getSpecificConfiguration(query) }

            if (config === undefined) {
                const response = await ConfigurationService.getConfiguration(query)
                await context.commit('updateConfiguration', [query, response.data])
            }
        }
    },
    getters: {
        getSpecificConfiguration: state => query => {
            const configuration = state.configurations
                .find(c => c.section === query.section && c.identifier === query.identifier)
            return configuration !== undefined
                ? configuration.config
                : undefined
        },
        getAllConfigurationsForSection: state => query => {
            const configuration = state.configurations
                .find(c => c.section === query.section)
            return configuration !== undefined
                ? configuration.config
                : undefined
        },
        getLanguageCode: (state, getters) => query => {
            let airportConfiguration = getters.getSpecificConfiguration({
                section: 'AirportConfigurations',
                identifier: query.identifier
            })
            if (airportConfiguration && airportConfiguration.cultureSettings) {
                return airportConfiguration.cultureSettings.languageCode
            }
            return null;
        },
        getSelectedAirportLanguageCode (state, getters, rootState, rootGetters) {
            const configuration = state.configurations
                .find(c => c.section === 'AirportConfigurations' && c.identifier === rootState.airport.selectedAirportId)

            if (configuration && configuration.config.cultureSettings) {
                return configuration.config.cultureSettings.languageCode
            }
            return null;
        },
        getSelectedAirportTimeZone (state, getters, rootState, rootGetters) {
            const configuration = state.configurations
                .find(c => c.section === 'AirportConfigurations' && c.identifier === rootState.airport.selectedAirportId)

            if (configuration && configuration.config.cultureSettings) {
                return configuration.config.cultureSettings.timeZone
            }
            return 'Europe/London'
        }
    }
}
